import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PageName } from '../../types';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher';

interface NavigationProps {
  onNavigate: (page: PageName, section?: string) => void;
}

const Navigation: React.FC<NavigationProps> = ({ onNavigate }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleNavigation = (page: PageName, section?: string) => {
    onNavigate(page, section);
    setIsOpen(false);
  };

  return (
    <div className="md:hidden">
      {/* Hamburger button */}
      <button
        onClick={toggleMenu}
        className="fixed top-4 right-4 z-50 p-2 rounded-md bg-blue-600 shadow-lg"
        aria-label="Menu"
      >
        <div className="space-y-2">
          <motion.span 
            className="block w-8 h-0.5 bg-white"
            animate={isOpen ? { rotate: 45, y: 10 } : { rotate: 0, y: 0 }}
          />
          <motion.span 
            className="block w-8 h-0.5 bg-white"
            animate={isOpen ? { opacity: 0 } : { opacity: 1 }}
          />
          <motion.span 
            className="block w-8 h-0.5 bg-white"
            animate={isOpen ? { rotate: -45, y: -10 } : { rotate: 0, y: 0 }}
          />
        </div>
      </button>

      {/* Mobile menu */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            className="fixed inset-0 bg-blue-900/95 backdrop-blur-md z-40"
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ type: "tween", duration: 0.3 }}
          >
            <nav className="h-full flex flex-col items-center justify-center relative">
               <div className="absolute top-4 left-4">
                 <LanguageSwitcher />
               </div>
              <ul className="space-y-8 text-center">
                <li>
                  <button
                    onClick={() => handleNavigation('about', 'about-us')}
                    className="text-white text-2xl font-semibold hover:text-blue-300 hover:scale-110 transition-all duration-200"
                  >
                    {t('navigation.about', 'O nas')}
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => handleNavigation('board')}
                    className="text-white text-2xl font-semibold hover:text-blue-300 hover:scale-110 transition-all duration-200"
                  >
                    {t('navigation.board', 'Zarząd')}
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => handleNavigation('home', 'contact')}
                    className="text-white text-2xl font-semibold hover:text-blue-300 hover:scale-110 transition-all duration-200"
                  >
                    {t('navigation.contact', 'Kontakt')}
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => handleNavigation('home', 'sponsors')}
                    className="text-white text-2xl font-semibold hover:text-blue-300 hover:scale-110 transition-all duration-200"
                  >
                    {t('navigation.partners', 'Partnerzy')}
                  </button>
                </li>
              </ul>
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Navigation;
